import React from 'react';
import './TargetLanding.css';
import image1 from "../../assets/Mockup.png";
import image2 from "../../assets/tools.png";
import Contact from '../contact/Contact'; // ✅ adjust path as needed

const TargetApp = () => {
    return (
        <main className="target-landing section">
            <div className="container">
                <h1 className="section__title">ToDo App UI</h1>

                <p>For the ToDo app dashboard project, I designed a sleek, user-centric interface aimed at simplifying task tracking and improving productivity. The layout combines minimalist aesthetics with practical usability, empowering users to stay organized effortlessly.</p>

                <div className='target-image-container'>
                    <img className="target-image" src={image1} alt="Target App Wireframe" />
                </div>

                <p>The final landing page was designed to not just inform but inspire and convert visitors into leads. By blending creativity with data-driven strategies, I ensured that the page resonates with Butterfly Real Estate’s clientele while achieving measurable business goals.</p>

                <h3>1. Visual Design Concept</h3>

                <p>This dashboard was carefully crafted to create a focused and clutter-free workspace. I used a clean layout, calming color palette, and soft shadows to reduce visual noise and guide user attention. The interface was structured around intuitive navigation, ensuring quick access to tasks, calendars, and priorities with minimal clicks.</p>
                <p>Bright accent colors were strategically placed to highlight key actions like task creation, due dates, and completion buttons—keeping the user visually engaged and motivated.
                </p>


                <h3>2. Design Tools Used:</h3>
                <ul className="target-features">
                    <li><strong>Figma:</strong> For wireframing, prototyping, and creating high-fidelity designs that are both responsive and visually stunning.</li>
                    <li><strong>Adobe Photoshop:</strong> For editing images, creating custom graphics, and enhancing visual elements like icons and buttons.</li>
                </ul>

                <div className='target-image-container'>
                    <img className="target-image" src={image2} alt="Target App Wireframe" />
                </div>

                <h3>Why This Design Works:</h3>
                <ul className="target-features">
                    <li><strong>Clean & Productive UI:</strong> The interface supports deep focus by eliminating distractions, letting users manage tasks with clarity.</li>
                    <li><strong>Scalable & Responsive:</strong> The layout adapts seamlessly to desktop, tablet, and mobile views, ensuring accessibility on all devices.</li>
                    <li><strong>Efficient Navigation:</strong> Tabs, filters, and search functions make task management fast and frictionless.</li>
                    <li><strong>Interactive Experience:</strong> The prototype allows users and clients to experience the design flow before development.</li>
                </ul>

                <h3>Available Now on Figma Community:</h3>
                <p>
                    <a
                        href="https://www.figma.com/community/file/1354648708560899189/real-state-website-landing-page"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'underline', color: 'inherit' }}
                    >
                        ButterFly - Figma Web UI
                    </a>
                </p>

                {/* Embedded Figma Prototype */}
                <div style={{ margin: '30px 0', display: 'flex', justifyContent: 'center' }}>
                    <iframe
                        src="https://embed.figma.com/design/V0brIv6gt68s15xdSWRJDu/To-Do-App?node-id=0-1&embed-host=share"
                        title="Figma ToDo App Design"
                        width="100%"
                        height="450"
                        allowFullScreen
                        style={{
                            maxWidth: '800px',
                            border: '1px solid rgba(0, 0, 0, 0.1)',
                            borderRadius: '10px'
                        }}
                    ></iframe>
                </div>

                <section className="target-cta">
                    <h3>Hire Me to Elevate Your Brand</h3>
                    <p>
                        If you’re looking to transform <strong>your website</strong> and create designs that leave a lasting impression, I’m here to deliver exceptional results. Let’s <strong>collaborate</strong> to bring your vision to life!
                    </p>
                </section>

                {/* ✅ Contact Form Directly Rendered Below */}
                <div style={{ marginTop: '40px' }}>
                    <Contact />
                </div>
            </div>
        </main>
    );
};

export default TargetApp;
